import { render, staticRenderFns } from "./Rectification.vue?vue&type=template&id=0c70ae53"
import script from "./Rectification.vue?vue&type=script&lang=js"
export * from "./Rectification.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports